export class TalentIdDriver {
    constructor({ id, name, idByBooking }) {
        this.id = id;
        this.name = name;
        this.idByBooking = idByBooking;
    }
}